import { dataClockwise } from 'dls-icons-data'
import { createIcon } from '../common'

const IconClockwise = /*#__PURE__*/createIcon(dataClockwise)
export default IconClockwise
